/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page, Section, Content, Copy, Title, Link, Grid, GridSet, GridItem, Icon, DateRangePickerDropDown, MultiSelectDropDown, ListTable, Control, LineChart } from '@insticator/insticator-ui'; // iui-material
//utils
import { isAfterFourPM, getDateNYC } from '@insticator/insticator-ui'; // iui-utils
import { transpileTableBody, transpileByDateTableColumnHead, detailChartData } from 'utils/transpilers/datavisualization';
import { generateMetricsAPIString } from 'utils/fetchcontenthelpers';
import { getAllDetailData } from 'utils/api/detail';
import { handleSiteInDropDown, handleCountriesInDropDown, handleDevicesInDropDown, tooltipHelper } from 'pages/dashboard/analytics/detail/detailhelpers';

// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/analytics/detail/metrics/revenue/revenue_styles';



/* ========== ~~~~~~~~~~ DATA REVENUE ~~~~~~~~~~ ========== */
class Revenue extends Component {
    constructor(props){
        super(props);
        this.topRank = 15;
        this.dataType = 'REVENUE';
        this.viewType = this.props.selectedRevenueType;
        this.state={
            controlSelected: `SITE`
        }
    }

    componentWillMount(){
        // let extendedProps = Object.keys(this.props.selectedSites).length ? {sites: this.props.selectedSites} : {topRank: this.topRank};
        let extendedProps = { topRank: this.topRank };
        this.fetchRevenueData(this.state.controlSelected, extendedProps);
    }
    componentWillUnmount() {
        this.props.clearDetailState();
    }
    //fetch data call
    fetchRevenueData = (controlSelected, extendAPIProps) => this.props.getDetailRevenueMetrics(generateMetricsAPIString({accountUUID: this.props.accountUUID, revenueType: this.viewType, dataType: this.dataType, dateRange: this.props.dateRange, viewType: controlSelected, ...extendAPIProps}), 'REVENUE');

    handleChartValue = data => {
        let value = data.total && data.total.aggregate ? data.total.aggregate : null;
        if (!value) return;
        return parseFloat(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    };
    //-=-=-=Control actions-=-=-=//
    handleSitesControlClick = () => {
        this.props.updateDetailDropDown([], 'SITE');
        this.setState({controlSelected: 'SITE'});
        this.fetchRevenueData('SITE', {topRank: this.topRank});
    };
    handleDevicesControlClick = () => {
        this.setState({controlSelected: 'DEVICE'});
        this.fetchRevenueData('DEVICE', {topRank: this.topRank});
    };
    handleGeoControlClick = () => {
        this.setState({controlSelected: 'GEO'});
        this.props.fetchCountries(this.props.accountUUID, `?startDate=${this.props.dateRange.from}&endDate=${this.props.dateRange.to}`);
        this.fetchRevenueData('GEO', {topRank: this.topRank});
    };
    handleAdUnitsControlClick = () => {
        this.setState({controlSelected: 'AD_UNIT'});
        this.props.fetchRONSites(this.props.accountUUID, `?startDate=${this.props.dateRange.from}&endDate=${this.props.dateRange.to}&filterRonSites=true`);
        this.fetchRevenueData('AD_UNIT', {topRank: this.topRank});
    };
    handleVideoAdsControlClick = () => {
        this.setState({controlSelected: 'AD_TYPE'});
        this.fetchRevenueData('AD_TYPE', {topRank: this.topRank});
    };
    //-=-=-=-=--Filter Data Dropdown actions -=-=-=-=//
    handleSitesFilterApply = sites => this.fetchRevenueData(this.state.controlSelected, { sites });
    handleDevicesFilterApply = devices => this.fetchRevenueData(this.state.controlSelected, { devices });
    handleGeoFilterApply = countries => this.fetchRevenueData(this.state.controlSelected, { countries });
    handleDateRangeApply = () => this.fetchRevenueData(this.state.controlSelected, {topRank: this.topRank});
    //this function will take selected items and populate reducer based on controlSelected state
    handleDropDownSelect = (items) => this.props.updateDetailDropDown(items, this.state.controlSelected);

    renderTitle = () => this.viewType ? this.viewType === 'VIDEO' ? 'Video Ad Revenue' : 'Display Ad Revenue' : 'Revenue';

    //this method returns an object that contains props needed to export current metrics that are displayed on screen in to an excel file
    //fileName and excludedColumns
    exportCurrentProps = () => ({
        fileName: this.dataType,
        excludedColumns: ['embed_uuid', '']
    });
    //this method returns an object that contains props needed to export current metrics that are displayed on screen in to an excel file
    //fileName, excludedColumns, and a paramstring that is used to make a BE call to fetch data for all sites, adunits, countries, etc. depending on current viewType
    exportAllProps = () => ({
        apiCall: getAllDetailData('revenue'),
        fileName: this.dataType,
        excludedColumns: ['embed_uuid', ''],
        transpiler: transpileTableBody,
        paramString: generateMetricsAPIString({
            accountUUID: this.props.accountUUID,
            dateRange: this.props.dateRange,
            viewType: this.state.controlSelected,
            dataType: this.dataType,
            revenueType: this.viewType
        })
    });
    //if client preSelected a viewType from home page this control will not be rendered
    renderVideoAdControl = () => !this.viewType ? <Control selected={this.state.controlSelected === `AD_TYPE`} text={`Ad Type`} value={`AD_TYPE`} handleSelect={this.handleVideoAdsControlClick} /> : null;

    render() {

        return(
            <Page name={`revenue`} klass={`${this.props.classes.revenue} filter-${this.state.controlSelected}`}>
                <Content>

                    <Section name={`detailheader`}>
                        <Grid>
                            <GridSet direction={`horizontal`} name={`detailtitle`}>
                                <GridItem>
                                    <Copy>
                                        <Link type={`internal`} behavior={`back`} text={`Back to all metrics`} color={`primary`} action={`dashboard/home`} icon={`hand-point-left`} />
                                        <Title><h2>{this.renderTitle()}</h2></Title>
                                    </Copy>
                                </GridItem>
                                <GridItem>
                                    <DateRangePickerDropDown handleApply={this.handleDateRangeApply} range={this.props.dateRange} disabledDays={[ { after: new Date(getDateNYC() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2))) } ]} updateRange={this.props.updateDateRange} use4PMLogic={true} />
                                </GridItem>
                            </GridSet>
                            <GridSet direction={`horizontal`} name={`detailfilters`}>
                                <GridItem name={`filters`}>
                                    <GridItem><MultiSelectDropDown variant={'all-sites'} name={this.props.selectedSites.length === 1 ? 'site' : 'sites'} title={'All Sites'} icon={`link`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleSitesFilterApply} items={handleSiteInDropDown(this.state.controlSelected === 'AD_UNIT' ? this.props.ronSites : this.props.sites)} selectedItems={this.props.selectedSites} disabled={this.state.controlSelected === 'AD_UNIT' ? !this.props.ronSitesReceived : !this.props.sitesReceived}/></GridItem>
                                    <GridItem><MultiSelectDropDown name={this.props.selectedDevices.length === 1 ? 'device' : 'devices'} title={'All Devices'} icon={`mobile-alt`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleDevicesFilterApply} items={handleDevicesInDropDown(this.props.devices)} selectedItems={this.props.selectedDevices}/></GridItem>
                                    <GridItem><MultiSelectDropDown name={this.props.selectedCountries.length === 1 ? 'country' : 'countries'} title={'All Countries'} icon={`globe`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleGeoFilterApply} items={handleCountriesInDropDown(this.props.countries)}  selectedItems={this.props.selectedCountries} disabled={!this.props.countriesReceived}/></GridItem>
                                </GridItem>
                                <GridItem direction={`horizontal`} name={`controls`}>
                                    <Control selected={this.state.controlSelected === `SITE`} text={`Sites`} value={`SITE`} handleSelect={this.handleSitesControlClick} />
                                    <Control selected={this.state.controlSelected === `DEVICE`} text={`Devices`} value={`DEVICE`} handleSelect={this.handleDevicesControlClick} />
                                    <Control selected={this.state.controlSelected === `GEO`} text={`Geo`} value={`GEO`} handleSelect={this.handleGeoControlClick} />
                                    <Control selected={this.state.controlSelected === `AD_UNIT`} text={`Ad Units`} value={`AD_UNIT`} handleSelect={this.handleAdUnitsControlClick} />
                                    {this.renderVideoAdControl()}
                                </GridItem>
                            </GridSet>
                        </Grid>
                    </Section>

                    <Section name={`detailchart`}>
                        <LineChart
                            type={`detail`}
                            label={this.renderTitle()}
                            value={this.handleChartValue(this.props.revenueDetail)}
                            tooltip={`This is the total ${tooltipHelper(this.props.selectedRevenueType)} revenue generated for you by Insticator`}
                            data={detailChartData(this.props.revenueDetail)}
                            metricType={'dollar'}
                            yType={'dollar'}
                            xType={'date'}
                            loading={this.props.fetchingRevenue}
                        />
                    </Section>

                    <Section name={`detailtable`}>
                        <ListTable
                            name={`revenue`}
                            type={`fixed-column`}
                            fixedColWidth={300}
                            size={`full`}
                            columnHeads={transpileByDateTableColumnHead(this.props.revenueDetail)}
                            data={transpileTableBody(this.props.revenueDetail, 'dollar')}
                            exportData={this.exportCurrentProps()}
                            exportAll={this.exportAllProps()}
                            paginationLocation={`top`}
                            rowsPerPage={7}
                            loading={this.props.fetchingRevenue}
                            moreDetails={false}
                        />
                    </Section>

                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

export default injectSheet(styles)(Revenue);
